import { render, staticRenderFns } from "./TextTemplateForm.vue?vue&type=template&id=1ccbe570&"
import script from "./TextTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./TextTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports